import { createSlice } from "@reduxjs/toolkit";
import { getSession } from "../global";

const types = getSession('types');

const d = {
    isCod: types && types.length > 0 ? types[0].value == 1 : null,
    subAccountId: '',
    locationId: '',
    autoCN: null,
    accountNo: ''
}

const BulkBookingSlice = createSlice({
    name: 'MapICCIDData',
    initialState: {
        data: d,
        fileLen: 0,
        fileName: '',
        fileType: null,
        grid: [],
        gridStatus: [],
    },
    reducers: {
        setData: (state, action) => {
            state.data = action.payload.data
        },
        setFileLen: (state, action) => {
            state.fileLen = action.payload.data
        },
        setFileName: (state, action) => {
            state.fileName = action.payload.data
        },
        setFileType: (state, action) => {
            state.fileType = action.payload.data
        },
        setGrid: (state, action) => {
            state.grid = action.payload.data
        },
        updateGrid: (state, action) => {
            const index = action.payload.index;
            const key = action.payload.key;
            const val = action.payload.val;
            state.grid[index][key] = val;
        },
        updateDestination: (state, action) => {
            const dests = action.payload.dests;
            console.log(dests);
            const index = action.payload.index;
            const val = action.payload.val;
            const dest = dests.filter(x => x.text === val);
            if (dest.length > 0) {
                const id = dest[0].value;
                state.grid[index]['DestinationId'] = id;
                state.grid[index]['DestinationCity'] = val;
            } else {
                state.grid[index]['DestinationId'] = '';
                state.grid[index]['DestinationCity'] = '';
            }
        },
        setGridStatus: (state, action) => {
            state.gridStatus = action.payload.data
        },
    }
});

export default BulkBookingSlice.reducer;
export const { setData, setFileLen, setFileType, setGrid, updateGrid, updateDestination, setGridStatus, setFileName } = BulkBookingSlice.actions;